import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import DatePicker from 'react-datepicker';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import cn from 'classnames';
import { Dropdown } from '../../../../components/Dropdown';
import { ManualDropdown } from '../../../../components/ManualDropdown';
import { Input } from '../../../../components/Input';
import { Loader } from '../../../../components/Loader';
import { Calendar } from '../../../../components/Icon';
import { deleteCompanyProperty, initiateNewCompnayValue, setNewCompanyAddress, setNewCompanyValue } from '../../actions';
import {
  selectCompanies,
  selectCompany,
  selectCountries,
  selectNewCompany,
  selectNewCompanyValue,
  selectParentCompanyName,
} from '../../selectors';
import { selectConfig, selectWork } from '../../../Api/selectors';
import {
  COMPANY_VINDAT_FRANCHISEFOMULE_OPTIONS,
  COMPANY_VINDAT_LEGAL_OPTIONS,
  COMPANY_VINDAT_RELATION_OPTIONS,
  LANGUAGES,
  REQUEST_COMPANY,
} from '../../constants';
import { HBox, VBox } from '../../../../components/Box';
import { selectAddressTypes } from '../../../Address/selectors';
import { getPropIdByName } from '../../../../utils/props';
import { SearchCompanyAndUser } from '../../../Users/components/SearchCompanyAndUser';
import { CompanyStructureSelection } from '../../components/CompanyStructureSelection';
import { Permission } from '../../../../components/Permission';
import {
  COMPANY_EDIT_COMPANY_TYPE,
  COMPANY_PARENT_EXACT,
  EDIT_COMPANY_STATUS,
} from '../../../../components/Permission/constants';
import { SearchSelect } from '../../../../components/SearchSelectComponent';
import styles from './Fields.module.css';
import CheckboxComponent from '../../../../containers/App/Components/Checkbox/Checkbox';
import { makeSelectLocale } from '../../../../containers/LanguageProvider/selectors';
import { translateCountry } from '../../translate-countries';
import env from '../../../../env';
import { AppClientId } from '../../../Shared/constants';

dayjs.extend(customParseFormat);
const DROPDOWN_OPTIONS = {
  company_type: ['individual', 'company'],
  status: ['0', '1', '2', '3', '4'],
};

const MANUAL_DROPDOWN_OPTIONS = {
  ORB_TDN_preference: ['ORB', 'TDN'],
  Vindat_Relation: COMPANY_VINDAT_RELATION_OPTIONS,
  Vindat_Franchisefomule: COMPANY_VINDAT_FRANCHISEFOMULE_OPTIONS,
  vindat_legal_form: COMPANY_VINDAT_LEGAL_OPTIONS,
  language: [],
};

const Container = styled.div`
  max-width: 600px;
  .row-input {
    display: flex;
    flex-direction: row;
    .col-1 {
      flex-basis: 20%;
    }
    .col-2 {
      flex-basis: 75%;
    }
  }
  margin-bottom: 8px;
  .formField {
    .label {
      text-transform: capitalize;
      margin-bottom: 6px;
      color: #6c757d;
    }
  }
`;

const RequireMark = styled.span`
  margin-left: 4px;
  font-size: 12px;
  color: red;
`;

const STATE = {
  address: {},
  addressLine1: '',
  postcode: '',
  city: '',
  countryId: null,
  countriesList: [],
};

/* eslint-disable react/prefer-stateless-function */
class CompanyCreateFieldComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.initiateValue();
    if (this.props.type === 'language' && this.props.value === undefined) {
      this.props.setValue('NL');
    }
    this.homeAddress && this.setState({ address: this.homeAddress });
  }

  componentDidUpdate(prevProps, prevState) {
    this.getAddressValues();
  }

  get countries() {
    return this.props.countries;
  }

  get locale() {
    return this.props.locale;
  }

  get company() {
    return this.props.company;
  }

  get homeAddress() {
    const addressTypeId = this.props.addressTypes.filter(t => t.name === 'home')[0].id;
    return this.company?.addresses.filter(a => a.typeId == addressTypeId)[0];
  }

  get wideInput() {
    return this.props.wientjes ? { minWidth: '500px' } : {};
  }

  get isNoValid() {
    return this.props.requiredFields?.includes(this.props.type);
  }

  getAddressValues() {
    const addressProps = { addressLine1: '', postcode: '', city: '', countryId: '' };
    for (let i in addressProps) {
      if (!this.props.values[i] && this.state.address[i]) {
        this.props.setValue(this.state.address[i], i);
        return this.setState((prev, props) => ({ ...prev, address: { ...prev.address, [`${i}`]: null } }));
      }
    }
  }

  isCheckbox() {
    return (
      [
        'incoming_block',
        'outgoing_block',
        'skip_KYC',
        'wait_for_pickup',
        'no_release_before_incoming_transport',
        'no_incoming_payment_before_transport',
      ].indexOf(this.props.type) > -1
    );
  }

  isDropbox() {
    return this.props.type in DROPDOWN_OPTIONS || this.props.type === 'countryId';
  }

  isManualDropbox() {
    return this.props.type in MANUAL_DROPDOWN_OPTIONS;
  }

  isDate() {
    return ['date_of_birth'].indexOf(this.props.type) > -1;
  }

  isPhoneNumber() {
    const check = this.props.type === 'phone_number';
    return check;
  }

  datePicker() {
    let format = this.props.value?.charAt(2) == '-' ? 'DD-MM-YYYY' : undefined;

    let selected = this.props.value && dayjs(this.props.value, format);
    return (
      <div className={cn('d-flex align-items-baseline', styles.containerDatePicker)}>
        <DatePicker
          className={styles.datePicker}
          dateFormat="dd-MM-yyyy"
          selected={selected && selected.toDate()}
          onChange={date => {
            let d = dayjs(date).format('DD-MM-YYYY hh:mm:ss');
            this.props.setValue(d);
          }}
        />
        <Calendar className={styles.iconCalendar} />
      </div>
    );
  }

  wrap(children) {
    const containsCheckbox = element => {
      if (React.isValidElement(element) && element.props) {
        return typeof element.props.className === 'string' && element.props.className.includes('checkbox');
      }
      return false;
    };

    const isCheckboxComp = React.Children.toArray(children).some(child => containsCheckbox(child));
    switch (this.props.type) {
      case 'company_type':
        if (isCheckboxComp) {
          return (
            <div>
              <Permission permission={COMPANY_EDIT_COMPANY_TYPE} proxy={this.props.value ?? 'company'}>
                {children}
              </Permission>
            </div>
          );
        }
        return (
          <div>
            <label className="form-label">{this.formFieldLabel()}</label>
            <Permission permission={COMPANY_EDIT_COMPANY_TYPE} proxy={this.props.value ?? 'company'}>
              {children}
            </Permission>
          </div>
        );

      case 'status':
        if (isCheckboxComp) {
          return (
            <div>
              <Permission permission={EDIT_COMPANY_STATUS} proxy={this.props.value ?? '-'}>
                {children}
              </Permission>
            </div>
          );
        }
        return (
          <div>
            <label className="form-label">{this.formFieldLabel()}</label>
            <Permission permission={EDIT_COMPANY_STATUS} proxy={this.props.value ?? '-'}>
              {children}
            </Permission>
          </div>
        );

      case 'exact_sync_to_parent':
        if (isCheckboxComp) {
          return (
            <div>
              <Permission
                permission={COMPANY_PARENT_EXACT}
                proxy={this.props.value ? 'exact_sync_to_parent: yes' : 'exact_sync_to_parent: no'}
              >
                {children}
              </Permission>
            </div>
          );
        }
        return (
          <div>
            <label className="form-label">{this.formFieldLabel()}</label>
            <Permission
              permission={COMPANY_PARENT_EXACT}
              proxy={this.props.value ? 'exact_sync_to_parent: yes' : 'exact_sync_to_parent: no'}
            >
              {children}
            </Permission>
          </div>
        );

      default:
        if (isCheckboxComp) {
          return <div>{children}</div>;
        }
        return (
          <div>
            <label className="form-label">{this.formFieldLabel()}</label>
            {children}
          </div>
        );

    }
  }

  isWithoutLabel = type => ['exact_sync_to_parent'].includes(type);

  formFieldLabel() {
    if (this.isCheckbox()) return null;
    return !this.isWithoutLabel(this.props.type) && this.lbl(`company.property.${this.props.type}`);
  }

  dropdown() {
    if (this.props.type == 'company_type' && !this.props.value) {
      this.props.setValue('company', this.props.type);
    }
    if (this.props.type == 'status' && !this.props.value) {
      this.props.setValue('0', this.props.type);
    }
    const vals = DROPDOWN_OPTIONS[this.props.type];
    let options =
      this.props.type === 'countryId'
        ? this.countries.map(c => ({ value: c.id, label: translateCountry(c.name, this.locale) }))
        : vals.map(val => ({
          label: this.lbl(`company.property.${this.props.type}.${val}`),
          value: val,
        }));

    if (this.props.type == '  ') {
      options = LANGUAGES.map(c => ({
        value: c.code,
        label: `${c.code}-${c.country}`,
      }));
    }
    const value = options.find(o => o.value == this.props.value);

    if (this.props.type === 'countryId') {
      return (
        <> <RequireMark>*</RequireMark>
          <SearchSelect
            options={options}
            // value={this.state.address?.countryId ? { label: this.state.address.country.name } : value}
            value={value}
            onChange={pair => {
              if (this.state.address?.countryId && this.props.type === 'countryId') {
                this.setState((prev, props) => ({ ...prev, address: { ...prev.address, countryId: '' } }));
              }
              this.props.setValue(pair.value);
            }}
          />

        </>
      );
    }
    return (
      <div className={cn((this.props.type === 'countryId' && 'dropdown-wrapper').toString(), styles.container)}>
        <Dropdown
          className={styles.dropdown}
          options={options}
          value={this.state.address?.countryId && this.props.type === 'countryId' ? this.state.address.country.name : value}
          onChange={pair => {
            if (this.state.address?.countryId && this.props.type === 'countryId') {
              this.setState((prev, props) => ({ ...prev, address: { ...prev.address, countryId: '' } }));
            }
            this.props.setValue(pair.value);

            if (
              this.props.type === 'company_type' &&
              pair.value === 'individual' &&
              env.clientId === AppClientId.AUTOWIENTJES
            ) {
              this.props.setValue('1', 'status');
            }

            if (
              this.props.type === 'company_type' &&
              pair.value === 'company' &&
              env.clientId === AppClientId.AUTOWIENTJES
            ) {
              this.props.setValue('0', 'status');
            }

            if (this.props.type == 'company_type') {
              this.props.values.company_type == 'company' &&
                this.props.resetValues(['name', 'surname', 'phone_number', 'email', 'date_of_birth']);

              this.props.values.company_type == 'individual' &&
                this.props.resetValues(['name', 'kvk_number', 'company_email', 'phone_number']);
            }
          }}
        />
      </div>
    );
  }

  manualDropdown() {
    let vals = MANUAL_DROPDOWN_OPTIONS[this.props.type];

    if (this.props.type == 'language') {
      vals = LANGUAGES.map(c => ({
        value: c.code,
        name: `${c.code}-${c.country}`,
      }));
      // vals = LANGUAGES;
    }
    return (
      <ManualDropdown
        model="company"
        key={this.props.type}
        type={this.props.type}
        editable={this.props.type != 'language'}
        deletable={this.props.company && this.props.company[this.props.type]}
        options={vals}
        onChange={value => this.props.setValue(value)}
        onReset={() => this.props.setValue('')}
        onDeleteValue={value => {
          const propId = getPropIdByName(this.props.company, this.props.type);
          this.props.deleteProperty(propId, this.props.company.id, result => {
            if (result === true) {
              this.props.setValue('');
            }
          });
        }}
        onManual={value => this.props.setValue(value, `${this.props.type  }_manual`)}
      />
    );
  }

  reset() {
    this.setState({ ...STATE });
  }

  phoneNumber() {
    const fields = ['country_code', 'phone_number'];
    return (
      <>
         {this.props.values.company_type == 'individual' &&  <RequireMark>*</RequireMark>}

      <VBox className="row-input">
        {fields.map((field, idx) => (
          <div key={field} className={`col-${idx + 1}`}>
            <HBox left>
              <input
                type="number"
                className="form-control"
                value={this.props.values[field] || ''}
                onChange={evt => this.props.setValue(evt.target.value, field)}
              />
            </HBox>
          </div>
        ))}
      </VBox>
      </>
    );
  }

  handleSubmit(e) {
    e.preventDefault();
    this.props.setAddress(this.state);
    return alert('The address has been added successfully');
  }

  countriesOptions() {
    return this.countries.map(c => ({ value: c.id, label: c.name }));
  }

  selectedCountry() {
    return this.state.countriesList.find(o => o.value === this.state?.countryId);
  }

  onAddressInputChange(evt) {
    const { name, value } = evt.target;
    this.setState((prev, props) => ({ ...prev, address: { ...prev.address, [name]: value } }));
    return this;
  }

  render() {
    if (this.props.work) return <Loader small />;
    if (!this.countries) return <Loader small />;
    return <Container>{this.wrap(this.renderField())}</Container>;
  }

  renderField() {
    if (this.props.value === undefined) return null;

    if (this.isDate()) {
      return this.datePicker();
    }

    if (this.isCheckbox()) {
      return (
        <CheckboxComponent
          className="checkbox"
          checked={this.props.value === '1'}
          onChange={() => {
            const value = this.props.value === '1' ? '0' : '1';
            return this.props.setValue(value);
          }}
          label={this.lbl(`company.property.${this.props.type}`)}
        />
      );
    }

    if (this.isDropbox()) {
      return this.dropdown();
    }

    if (this.isManualDropbox()) {
      return this.manualDropdown();
    }

    if (this.isPhoneNumber()) {
      return this.phoneNumber();
    }

    switch (this.props.type) {
      case 'surname':
        return (
          <>
          <RequireMark>*</RequireMark>
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          /></>
        );

      case 'name':
        return (<>
          <RequireMark>*</RequireMark>
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          /></>
        );
      case 'kvk_number':
        return (
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
      case 'website':
        return (
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
      case 'company_email':
        return (
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
      case 'email':
        return (
          <><RequireMark>*</RequireMark><input
            className="form-control"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)} /></>
        );
      case 'addressLine1':
        return (
          <>
          <RequireMark>*</RequireMark>
          <input
            className="form-control"
            placeholder="Street Name and house number"
            key={this.props.type}
            value={this.props.value ? this.props.value : this.state.address.addressLine1}
            onChange={evt => this.props.setValue(evt.target.value)}
          /></>
        );
      case 'postcode':
        return (
          <>
          <RequireMark>*</RequireMark>
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value ? this.props.value : this.state.address.postcode}
            onChange={evt => this.props.setValue(evt.target.value)}
          /></>
        );
      case 'city':
        return (
          <>
          <RequireMark>*</RequireMark>
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value ? this.props.value : this.state.address.city}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
          </>
        );
      case 'accountManagerId':
        return (
          <>
            <SearchCompanyAndUser
              homeCompanyId="4"
              key={`${this.props.type}-${this.props.value}`}
              type={this.props.type}
              value={this.props.value}
              onSelect={value => this.props.setValue(value?.id)}
            />
          </>
        );
      case 'owner_name':
        return (
          <Input
            style={{ width: '500px' }}
            type="email"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
      case 'type_ID':
        return (
          <Input
            style={{ width: '500px' }}
            type="email"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
      case 'ID_number':
        return (
          <Input
            style={{ width: '500px' }}
            type="email"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
      case 'expiration_date':
        return (
          <Input
            style={{ width: '500px' }}
            type="email"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
      case 'RDW_number':
        return (
          <input
            className="form-control"
            type="number"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
      case 'parentCompany':
        return (
          <>
            {!!this.company?.parentCompany && this.company?.parentCompany?.name}
            {this.company && <CompanyStructureSelection company={this.company} relation="parent" variant="sync" />}
            {!this.company && (
              <HBox vCenter left>
                You can't select parent company before create this company.
              </HBox>
            )}
          </>
        );
      case 'exact_sync_to_parent':
        return (
          <CheckboxComponent
            className="checkbox"
            label={this.lbl(`vehicle.property.${this.props.type}`)}
            key={this.props.type}
            checked={!!this.props.value}
            onChange={() => this.props.setValue(this.props.value === 1 ? 0 : 1)}
          />
        );
    }
  }
}

CompanyCreateFieldComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    config: selectConfig(),
    work: selectWork(REQUEST_COMPANY),
    value: selectNewCompanyValue(ownProps.type),
    values: selectNewCompany(),
    company: selectCompany(ownProps.company_id),
    countries: selectCountries(),
    companies: selectCompanies(),
    addressTypes: selectAddressTypes(),
    parentCompanyName: selectParentCompanyName(ownProps.company_id),
    locale: makeSelectLocale(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    setValue(value, name = null) {
      name = name ?? ownProps.type;
      dispatch(setNewCompanyValue(name, value));
    },
    setAddress(address) {
      dispatch(setNewCompanyAddress(address));
    },
    initiateValue() {
      dispatch(initiateNewCompnayValue(ownProps.type));
    },
    deleteProperty(propertyId, companyId, callback) {
      dispatch(deleteCompanyProperty(propertyId, companyId, callback));
    },
    resetValues(values, name = null) {
      values.map(type => dispatch(setNewCompanyValue(type, '')));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CompanyCreateField = compose(withConnect, withRouter)(CompanyCreateFieldComp);
